import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class RequestJudicialStageAdvanceResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "name": "Judicial Management Request",
                "timestamp": "2024-05-20T10:00:00",
                "requester": "sapore@eryxsoluciones.com.ar",
                "requested_stage": "prejudicial_management",
                "reason": "Customer has overdue debt beyond the allowed threshold",
                "overdue_invoices_count": 1,
                "overdue_invoices_total_pending_balance": {"amount": 1000.00, "currency": "ARS"},
                "object_with_action_requested": {
                    "customer": {
                        "code": "123",
                        "fantasy_name": "Client123",
                        "business_name": "Client123BN123",
                        "number": "1234",
                        "taxpayer_identification_number": 123,
                        "delivery_sites": []
                    },
                    "outstanding_balance": {"amount": 10000.00, "currency": "ARS"},
                    "overdue_balance": {"amount": 2500.00, "currency": "ARS"},
                    "unassigned_balance": {"amount": 0.00, "currency": "ARS"},
                    "total_balance": {"amount": 12500.00, "currency": "ARS"},
                    "has_no_overdue_tolerance": false,
                    "judicial_stage": "without_judicial_management"
                }
            },
            errors: []
        }
    }
}
